import {onAuthStateChanged} from 'firebase/auth';
import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react';

import {auth} from 'services/AuthService';
import {getServices} from 'services/index';
import User from 'services/User';

export interface IAuthContext {
  user: User;
  setUser: Dispatch<SetStateAction<User | undefined>>;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

const AuthContext = createContext<Partial<IAuthContext>>({});
const {Provider} = AuthContext;

const AuthProvider = ({children}: {children: ReactNode}) => {
  const [user, setUser] = useState<User>();
  const [isLoading, setIsLoading] = useState(true);
  const unsubscribe = useRef<() => void>();

  useEffect(() => {
    if (typeof unsubscribe.current === 'function') {
      unsubscribe.current();
    }
    unsubscribe.current = onAuthStateChanged(auth, async (authUser) => {
      if (authUser == null) {
        setUser(undefined);
        setIsLoading(false);
        return;
      }
      const usr = new User(authUser);
      const {authService} = getServices();
      await authService.updateUser(usr);
      setUser(usr);
      setIsLoading(false);
    });
    return () => {
      if (typeof unsubscribe.current === 'function') {
        unsubscribe.current();
      }
    };
  }, []);

  return (
    <Provider
      value={{
        user,
        setUser,
        isLoading: isLoading && !user,
        setIsLoading,
      }}
    >
      {children}
    </Provider>
  );
};

export {AuthContext, AuthProvider};
